import * as actionTypes from "../actionTypes";

const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NEW_DENOMINATION:
      state = {
        ...state,
        allData: action.payload,
      };
      break;
    case actionTypes.ADD_NEW_DENOMINATION:
      state = {
        ...state,
        allData: [action.payload, ...state.allData],
      };
      break;
    case actionTypes.REMOVE_AN_DENOMINATION:
      state = {
        ...state,
        allData: state.allData.filter(
          (denomination) => denomination.AMOUNT !== action.payload.AMOUNT,
        ),
      };
      break;
    case actionTypes.UPDATE_QUANTITY_DENOMINATION:
      state = {
        ...state,
        allData: state.allData.map((denomination) => {
          if (denomination.AMOUNT === action.payload.AMOUNT) {
            const amount = Number(denomination.AMOUNT) || 0;
            const qty = Number(action.payload.QUANTITY) || 0;
            const discount = Number(denomination.DISCOUNT) || 0;
            const discountType = denomination.DISCOUNT_TYPE;

            const grossTotal = qty * amount;

            let discountTotal = 0;
            let cashbackTotal = 0;

            let netTotal = grossTotal;

            if (discountType === "DISCOUNT") {
              discountTotal = (grossTotal * discount) / 100;
              netTotal = grossTotal - discountTotal;
            }
          if (discountType === "CASHBACK") {
  cashbackTotal = (grossTotal * discount) / 100;
  netTotal = grossTotal;
}

            return {
              ...denomination,
              QUANTITY: qty,
              TOTAL: netTotal,
              GROSS_TOTAL_DISCOUNT: discountTotal,
              CASHBACK_AMOUNT: cashbackTotal,
            };

          }

          return denomination;
        }),
      };
      break;
    case actionTypes.WIPE_OUT_DENOMINATION:
      state = { allData: [] };
      break;
    default:
      state = { ...state };
  }
  return state;
};

export default reducer;
